import dayjs from 'dayjs';
import { Chip } from '../../chip/Chip';
import { LinkButton } from '../../link/LinkButton';
import { ChipLabelFilterType } from '../interface';
import { FilterContentFieldDataTypes } from '../constants';

interface FilterChipSectionProps {
  filter: ChipLabelFilterType;
  clearFilter: (filter: string, value: unknown) => void;
  clearSection: (filter: string) => void;
}

export function FilterChipSection({ filter, clearFilter, clearSection }: FilterChipSectionProps) {
  const getLabel = (value: unknown) => {
    if (filter.operator) {
      if (filter.filterType === FilterContentFieldDataTypes.DATE) {
        return (
          `${'Between '} ` +
          `${dayjs((filter.value as Array<string>)[0]).format('DD-MM-YYYY')} And ${dayjs(
            (filter.value as Array<string>)[1]
          ).format('DD-MM-YYYY')}`
        );
      }

      if (
        typeof filter.value === 'object' &&
        'value' in (filter.value as { label: string; value: string })
      ) {
        return (filter.value as { label?: string }).label;
      }

      return `${filter.operator} ${filter.value}`;
    }

    return (value as { label: string }).label || (value as string);
  };

  return (
    <div className='mt-3 px-3'>
      <div className='d-flex justify-between'>
        <p className='text-caption-1 text-secondary'>{filter.title}</p>

        <LinkButton
          dataId={`${filter.filter}-clear-section`}
          icon='close'
          direction='left'
          onClick={() => clearSection(filter.filter)}
        >
          Clear
        </LinkButton>
      </div>

      <div className='center-flex-row  mr-4 flex-wrap'>
        {Array.isArray(filter.value) && filter.operator !== 'RANGE' ? (
          filter.value.map((value, index) => {
            return (
              <>
                <Chip
                  dataId={`${filter.filter}-${index}`}
                  className='mt-3 mr-5'
                  label={getLabel(value)}
                  onDelete={() => clearFilter(filter.filter, value)}
                />

                {index < (filter.value as Array<unknown>).length - 1 ? (
                  <p className=' pl-1 pr-6 mt-3 text-caption-1 text-secondary'>OR</p>
                ) : null}
              </>
            );
          })
        ) : (
          <Chip
            dataId={filter.filter}
            className='mt-3 mr-5'
            label={getLabel(filter.value)}
            onDelete={() => clearFilter(filter.filter, filter.value)}
          />
        )}
      </div>
    </div>
  );
}
